import { render, staticRenderFns } from "./FormDataList.vue?vue&type=template&id=0132a8f2&scoped=true&"
import script from "./FormDataList.vue?vue&type=script&lang=js&"
export * from "./FormDataList.vue?vue&type=script&lang=js&"
import style0 from "./FormDataList.vue?vue&type=style&index=0&id=0132a8f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0132a8f2",
  null
  
)

export default component.exports